import MergeTagsEditing from './MergeTagsEditing';
import MergeTagsUI from './MergeTagsUI';
import { Plugin } from 'ckeditor5';

export default class MergeTagsPlugin extends Plugin {
    static get requires() {
        return [MergeTagsEditing, MergeTagsUI];
    }
}
